import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const cancelPricingPlan = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `billing/cancel-plan`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}
